/**
 * Product Urgency & Demand Indicators
 * Handles live viewer count simulation and dynamic stock updates.
 */
(function () {
  'use strict';

  function initUrgency() {
    var viewersCountEl = document.getElementById('lvd-viewers-count');
    if (!viewersCountEl) return;

    // Simulate subtle live viewer fluctuations
    var minViewers = 11;
    var maxViewers = 27;

    function updateViewers() {
      var current = parseInt(viewersCountEl.textContent, 10) || 16;
      var delta = Math.floor(Math.random() * 5) - 2; // -2 to +2
      var next = current + delta;

      if (next < minViewers) next = minViewers + Math.floor(Math.random() * 3);
      if (next > maxViewers) next = maxViewers - Math.floor(Math.random() * 3);

      viewersCountEl.textContent = next;
    }

    // Interval between 8 and 14 seconds
    setInterval(updateViewers, 9000);

    // Dynamic variant change listener for stock count
    var productForm = document.querySelector('product-form') || document.getElementById('product-form');
    if (productForm) {
      productForm.addEventListener('change', function () {
        var variantInput = productForm.querySelector('[name="id"]');
        if (!variantInput) return;

        var variantId = variantInput.value;
        var stockWrapper = document.getElementById('lvd-stock-wrapper');
        var stockCountEl = document.getElementById('lvd-stock-count');
        var stockBarEl = document.getElementById('lvd-stock-bar');

        // Check if global product variants qty map exists
        var qtyMap = window.lvdProductVariantsQty || {};
        if (qtyMap[variantId] !== undefined) {
          var qty = qtyMap[variantId];
          if (qty > 0 && qty <= 10) {
            if (stockWrapper) stockWrapper.style.display = 'block';
            if (stockCountEl) stockCountEl.textContent = qty;
            if (stockBarEl) stockBarEl.style.width = (qty * 10) + '%';
          } else {
            if (stockWrapper) stockWrapper.style.display = 'none';
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUrgency);
  } else {
    initUrgency();
  }
})();
